import { api } from 'services/api/baseBackendAPI';

export const companyApi = api.injectEndpoints({
  endpoints: (build) => ({
    addCompany: build.mutation({
      query: (options) => ({
        url: `funds/addOrganization`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        return ['Company'];
      },
    }),
    getListCompany: build.query({
      query: () => ({
        url: `funds/getListCompanies`,
        method: 'GET',
      }),
      providesTags: ['Company'],
      transformResponse: (response) => {
        return response.data;
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
    }),
    getGroupedPortfolioCompanyBySector: build.query({
      query: () => ({
        url: `funds/get-all-portfolio-company-sectors`,
        method: 'GET',
      }),
      providesTags: ['Company Sector'],
    }),
    getGroupedSectorsAndCounts: build.query({
      query: (requestObject) => ({
        url: `funds/get-all-fund-sectors-counts`,
        method: 'GET',
        params: requestObject,
      }),
      providesTags: (result, error, arg) => [
        {
          type: 'SectorCounts',
          id:
            arg?.portfolio_id && arg?.fiscal_year
              ? `${arg.portfolio_id}-${arg.fiscal_year}`
              : 'LIST',
        },
      ],
    }),
  }),
  overrideExisting: true,
});
export const {
  useAddCompanyMutation,
  useGetListCompanyQuery,
  useGetGroupedPortfolioCompanyBySectorQuery,
  useGetGroupedSectorsAndCountsQuery,
} = companyApi;
